import Platform from"react-native-web/dist/exports/Platform";const usePlatform=args=>{if(true){return args.web;}return args.native;};export default usePlatform;